namespace TabAurous.OMS {
    export interface DesignBOMForm {
        ItemTypeId: Serenity.IntegerEditor;
        ProductTypeId: Serenity.LookupEditor;
        BOMDesignId: Serenity.ServiceLookupEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        BOMAttributeId: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        ItemType: Serenity.StringEditor;
        Attribute: Serenity.StringEditor;
        KaratId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        GroupSieveId: Serenity.IntegerEditor;
        StoneSizeId: StoneSizeLookup;
        SieveId: StoneSieveLookup;
        MetalColorId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        SettingId: Serenity.LookupEditor;
        StoneCutId: Serenity.LookupEditor;
        StonePolishId: Serenity.LookupEditor;
        StoneSymmetryId: Serenity.LookupEditor;
        StoneFluorescenceId: Serenity.LookupEditor;
        StoneCuletId: Serenity.LookupEditor;
        StoneGirdleId: Serenity.LookupEditor;
        StoneTable: Serenity.StringEditor;
        StoneDepth: Serenity.StringEditor;
        Purity: Serenity.DecimalEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        PureWeight: Serenity.DecimalEditor;
        CalcOnId: Serenity.LookupEditor;
        Remarks: Serenity.StringEditor;
        PointerWeight: Serenity.DecimalEditor;
        CenterStone: Serenity.BooleanEditor;
    }

    export class DesignBOMForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.DesignBOM';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DesignBOMForm.init)  {
                DesignBOMForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;
                var w2 = s.ServiceLookupEditor;
                var w3 = CommonCategoryLookup;
                var w4 = CommonSubCategoryLookup;
                var w5 = s.StringEditor;
                var w6 = StoneSizeLookup;
                var w7 = StoneSieveLookup;
                var w8 = s.DecimalEditor;
                var w9 = s.BooleanEditor;

                Q.initFormType(DesignBOMForm, [
                    'ItemTypeId', w0,
                    'ProductTypeId', w1,
                    'BOMDesignId', w2,
                    'CategoryId', w3,
                    'SubCategoryId', w4,
                    'BOMAttributeId', w5,
                    'ProductCode', w5,
                    'ItemType', w5,
                    'Attribute', w5,
                    'KaratId', w1,
                    'ShapeId', w1,
                    'GroupSieveId', w0,
                    'StoneSizeId', w6,
                    'SieveId', w7,
                    'MetalColorId', w1,
                    'StoneColorId', w1,
                    'QualityId', w1,
                    'SettingId', w1,
                    'StoneCutId', w1,
                    'StonePolishId', w1,
                    'StoneSymmetryId', w1,
                    'StoneFluorescenceId', w1,
                    'StoneCuletId', w1,
                    'StoneGirdleId', w1,
                    'StoneTable', w5,
                    'StoneDepth', w5,
                    'Purity', w8,
                    'Pieces', w0,
                    'Weight', w8,
                    'PureWeight', w8,
                    'CalcOnId', w1,
                    'Remarks', w5,
                    'PointerWeight', w8,
                    'CenterStone', w9
                ]);
            }
        }
    }
}
